import { languageIds } from './languageIds';
import { regionIds } from './regionIds';

export const languages = [
    {
        id: languageIds.enUS,
        name: 'English',
        supportedRegions: [
            regionIds.africa,
            regionIds.asia,
            regionIds.australia,
            regionIds.canada,
            regionIds.caribbean,
            regionIds.centralAmerica,
            regionIds.middleEast,
            regionIds.oceania,
            regionIds.southAmerica,
            regionIds.usa
        ],
        active: true
    }, {
        id: languageIds.esES,
        name: 'Español',
        supportedRegions: [
            regionIds.usa,
            regionIds.mexico,
            regionIds.centralAmerica,
            regionIds.southAmerica,
            regionIds.caribbean,
            regionIds.southAmerica,
            regionIds.europe,
        ],
        active: true
    }, {
        id: languageIds.ptPT,
        name: 'Português',
        supportedRegions: [],
        active: false
    }, {
        id: languageIds.hrHR,
        name: 'Hrvatski',
        supportedRegions: [],
        active: false
    }, {
        id: languageIds.itIT,
        name: 'Italiano',
        supportedRegions: [],
        active: false
    },
    {
        id: languageIds.enGB,
        name: 'English',
        supportedRegions: [
            regionIds.europe
        ],
        active: true
    }, {
        id: languageIds.frCA,
        name: 'Français',
        supportedRegions: [
            regionIds.canada
        ],
        active: true
    }, {
        id: languageIds.frFR,
        name: 'Français',
        supportedRegions: [
            regionIds.africa,
            regionIds.asia,
            regionIds.australia,
            regionIds.caribbean,
            regionIds.centralAmerica,
            regionIds.europe,
            regionIds.middleEast,
            regionIds.oceania,
            regionIds.southAmerica,
        ],
        active: true
    }, {
        id: languageIds.deDE,
        name: 'Deutsch',
        supportedRegions: [
            regionIds.africa,
            regionIds.asia,
            regionIds.australia,
            regionIds.caribbean,
            regionIds.centralAmerica,
            regionIds.europe,
            regionIds.middleEast,
            regionIds.oceania,
            regionIds.southAmerica,
        ],
        active: true
    }
];

export const getLanguageById = languageId => languages.find(l => l.id === languageId);

export const getLanguagesByRegionId = ( regionId ) => {
    return languages.filter(lang => {
        return lang.supportedRegions.indexOf(regionId) > -1 && lang.active === true;
    });
};

export const getLanguageByName = name => languages.find(l => l.name === name);



// WEBPACK FOOTER //
// ./src/lib/localization/languages.js